import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
var OptionService = /** @class */ (function () {
    function OptionService(_http) {
        this._http = _http;
        this.url = GLOBAL.url;
    }
    OptionService.prototype.getServices = function () {
        var headers = new Headers({
            'Content-type': 'application/json',
        });
        return this._http.get(this.url + 'get/services', { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    return OptionService;
}());
export { OptionService };
